import { GLOBALCONFIG_ROUTE_NAME } from '@/libs/route-name'

export const globalconfigRoute = () => {
  return {
    name: GLOBALCONFIG_ROUTE_NAME.GLOBALCONFIG,
    path: 'globalconfig',
    component: () => import('@/pages/globalconfig/index.vue'),
  }
}
